export default {
  version: 0,
  dbName: '',
  db: '',
  store: '',

  open(cb) {
    if (!('indexedDB' in window)) {
      return Promise.reject("This browser doesn't support IndexedDB")
    }
    let self = this
    //returning a promise
    return new Promise((resolve, reject) => {
      var request = window.indexedDB.open(this.dbName, this.version)

      request.onerror = function(event) {
        reject(event)
      }
      request.onsuccess = function(event) {
        self.db = event.target.result
        resolve(self.db)
      }

      request.onupgradeneeded = function(event, resolve) {
        // Save the IDBDatabase interface
        self.db = event.target.result
        cb(self.db, resolve)
      }
    })
  },
  createStore(store, attrs, indexes) {
    return new Promise(resolve => {
      if (!this.db.objectStoreNames.contains(store)) {
        var objectStore = this.db.createObjectStore(store, attrs)

        if (indexes) {
          indexes.forEach(index => {
            store.createIndex(index.key, index.value, index.attrs)
          })
        }

        //objectStore.createIndex()
        objectStore.transaction.oncomplete = function(event) {
          resolve(event)
        }
      } else {
        resolve()
      }
    })
  },
  setStore(store) {
    this.store = store
  },
  setVersion(version) {
    this.version = version
  },
  setName(name) {
    this.dbName = name
  },

  find(key) {
    return new Promise(resolve => {
      var tx = this.db.transaction(this.store, 'readonly')
      var objectStore = tx.objectStore(this.store)
      var objectStoreRequest = objectStore.get(key)
      objectStoreRequest.onsuccess = function(event) {
        resolve(objectStoreRequest.result)
      }
    })
  },

  write(data) {
    return new Promise(resolve => {
      var tx = this.db.transaction(this.store, 'readwrite')
      var objectStore = tx.objectStore(this.store)

      var objectStoreRequest = objectStore.add(data)
      objectStoreRequest.onsuccess = function(event) {
        resolve(event)
      }
    })
  },

  delete(key) {
    return new Promise(resolve => {
      var tx = this.db.transaction(this.store, 'readwrite')
      var objectStore = tx.objectStore(this.store)
      var objectStoreRequest = objectStore.delete(key)

      objectStoreRequest.onsuccess = function(event) {
        resolve(event)
      }
    })
  },

  update(data) {
    return new Promise(resolve => {
      var tx = this.db.transaction(this.store, 'readwrite')
      var objectStore = tx.objectStore(this.store)
      var objectStoreRequest = objectStore.put(data)

      objectStoreRequest.onsuccess = function(event) {
        resolve(event)
      }
    })
  },
}
